// Real image URLs scraped from bookmystudiospace.com
export const siteImages = {
  // Slider/hero images
  heroSlider1: "/__l5e/assets-v1/c0cd7627-16fc-49ce-abfe-465f89318c2b/Slider.jpg",
  heroSlider2: "/__l5e/assets-v1/f9e83a7a-81b2-4d83-8b08-f4fd548e7dd2/Slider2.jpg",

  // Logo
  logo: "/__l5e/assets-v1/39ad8586-c45f-403b-a6b7-00afe017c96b/MyStudio_Logo_Studio.png",

  // Service icons
  serviceIcon1: "/__l5e/assets-v1/049c3ec9-fdba-499c-bdda-ee29edac003d/about-icon-1.png",
  serviceIcon2: "/__l5e/assets-v1/0df999e8-b788-4747-8b6e-93625b4aa37f/hp-service-icon-2.png",
  editingIcon: "/__l5e/assets-v1/34f0b67b-40d1-44d5-b928-70f95e763207/editing-icon.png",

  // Portfolio / Gallery
  portfolioBW1: "/__l5e/assets-v1/290744de-dca8-4229-a09e-a643e2e2e079/Portfolio-BW-1-600x800.jpg",
  portfolioBW5: "/__l5e/assets-v1/a7df859d-ccc7-47f2-afb5-30501207a2db/Portfolio-BW-5-600x800.jpg",
  portfolioBW6: "/__l5e/assets-v1/6892e810-e6ce-4d33-85af-b2211efe1454/Portfolio-BW-6-1-600x800.jpg",
  portfolioBirthdays: "/__l5e/assets-v1/80b4aa2d-3383-4680-8b4a-46193ee4e30c/MyStudio_Portfolio-Birthdays-600x800.jpg",
  portfolioOutside: "/__l5e/assets-v1/ba9a7a28-1f04-46b4-890b-8e5ae6bc4b83/MyStudio_Portfolio-OutsideStudio-600x800.jpg",

  // Team member headshots
  cedric: "/__l5e/assets-v1/73d82765-14f5-40bb-a355-19157676f2fd/Personnel-Cedric-700x853.jpg",
  tabitha: "/__l5e/assets-v1/85981944-86fd-4313-9c08-da9c6b1d30c4/tab-editorial-1-700x935.jpg",
  pentaxxGuy: "/__l5e/assets-v1/7f7074a1-3580-4788-b7b5-c7d6426cdda9/pentaxx-guy-102-700x935.jpg",
  gary: "/__l5e/assets-v1/9bb34835-244e-4dc0-ba3e-e56be3733636/gary-700x853.jpg",
  rachael: "/__l5e/assets-v1/cc320053-17da-47ba-a9b1-f41fc76e913b/rach-banks-web-1-700x853.jpg",
  deontae: "/__l5e/assets-v1/ddec478d-7ab3-410d-a0d6-b4719a6a29c8/deontae-700x853.jpg",

  // Facilities
  studioAid: "/__l5e/assets-v1/f3e42060-b11f-4f89-be1c-d7636a1e2bd2/Studio_Aid-1-1-700x450.jpg",
  studioProp: "/__l5e/assets-v1/d5a6d593-3e6e-4eeb-bfac-50c9a3602519/Studio_Prop-1.jpg",
  studioSet: "/__l5e/assets-v1/52a04afc-6d28-4293-acef-535f6689485b/Studio_Set-1-700x450.jpg",
  consultationImage: "/__l5e/assets-v1/113e05a0-c880-451d-b4e4-8774e27fa516/Additional-Info-Homepage-Bordered.jpg",

  // Blog post hero images
  blogPersonalBrand: "/__l5e/assets-v1/20ca3c96-8d0c-4994-9009-097248184935/Personnel-Cedric-700x450.jpg",
  blogCommercial: "/__l5e/assets-v1/16b6870e-05fc-4606-9f2d-01301d5584e5/Portfolio-BW-3-700x450.jpg",
  blogShortFilm: "/__l5e/assets-v1/64f97356-1408-4fff-a4e7-0bab60267f67/pexels-photo-38196-700x450.jpeg",

  // Brand logos
  sonyLogo: "/__l5e/assets-v1/213fe86c-9acd-4c72-8c45-8d443e166c5c/sony-logo-1.png",
  canonLogo: "/__l5e/assets-v1/5569801f-bbaa-4f0b-a401-980fea99fe5a/canon-logo-1.png",
  lumixLogo: "/__l5e/assets-v1/61090e06-5d25-4368-9681-c9cdb94d1213/lumix-logo.png",
  blackmagicLogo: "/__l5e/assets-v1/fbb63726-a0c8-40ad-9299-0b849180fcd4/Blackmagic_Design_logo-1.png",
  savageLogo: "/__l5e/assets-v1/d2618131-48dc-4dd4-b048-487cf067dc59/savage-logo.png",
};

// Real social media links
export const socialLinks = {
  facebook: "http://facebook.com/MyStudioColumbus/",
  instagram: "http://instagram.com/mystudiocolumbus",
  pinterest: "https://www.pinterest.com/bookmystudiospace",
  twitter: "https://twitter.com/mystudiocolga",
  youtube: "https://www.youtube.com/channel/UCbbSEavVQWrDLtWGgn7p4-g/featured",
  linkedin: "http://linkedin.com/company/mystudiocolumbus",
};
